/// <amd-module name="Wit/WorkItemForm/Links/Controls/LinksMoreButton" />
import * as React from "react";
import { useMemo } from "react";
import { IContextualMenuProps, MoreButton } from "VSSUI/Menu";
import * as Resources from "Wit/WorkItemForm/Resources";

interface ILinksMoreButtonProps {
    className?: string;
    onEditLink: () => void;
    onDeleteLink: () => void;
    editAction: LinksMoreEditAction;
}

export enum LinksMoreEditAction {
    EditComment,
    EditLink
}

export function LinksMoreButton({ className, onEditLink, onDeleteLink, editAction }: ILinksMoreButtonProps) {
    const menu: IContextualMenuProps = useMemo(
        () => ({
            menuProps: {
                id: "attachment-menu",
                items: [
                    {
                        id: editAction === LinksMoreEditAction.EditComment ? "edit-comment" : "edit-link",
                        groupKey: "link-actions",
                        iconProps: { iconName: "Edit" },
                        text: editAction === LinksMoreEditAction.EditComment ? Resources.EditComment : Resources.EditLink,
                        onActivate: onEditLink
                    },
                    {
                        id: "delete-link",
                        groupKey: "link-actions",
                        iconProps: { iconName: "Delete" },
                        text: Resources.DeleteLink,
                        onActivate: onDeleteLink
                    }
                ]
            }
        }),
        [onEditLink, onDeleteLink, editAction]
    );

    return <MoreButton className={className} hideDropdownIcon subtle contextualMenuProps={menu} />;
}
